import { useState, useLayoutEffect, useRef } from "react";
import * as Scrivito from "scrivito";

export const useProductImage = (pimId: string) => {
  const [productImage, setProductImage] = useState<string | null>(null);
  const [fetching, setFetching] = useState(false);
  const [error, setError] = useState(null);
  const previousPimId = useRef<string | null>(null);

  useLayoutEffect(() => {
    const pimIdChanged = previousPimId.current !== pimId;
    if (pimId && (pimIdChanged || !productImage) && !fetching && !error) {
      const cachedImage = getImageUrlFromSessionStorage(pimId);
      if (!cachedImage) {
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setFetching(true);
        loadProductImage(pimId)
          .then((image) => {
            if (image) {
              setProductImage(image);
              sessionStorage.setItem(pimId, image);
            }
          })
          .catch((err) => {
            setError(err);
            console.error(`Failed to fetch product image: ${err}`);
          })
          .finally(() => {
            setFetching(false);
          });
      } else {
        setProductImage(cachedImage);
      }
    }
  }, [error, fetching, pimId, productImage]);

  return {
    productImage,
    fetching,
    error,
  };
};

async function loadProductImage(pimId: string) {
  // TODO: When AB will be ready and providing us img URLs (or Binaries) we may get rid of loadProductImage at all
  const obj = await Scrivito.load(() =>
    Scrivito.Obj.where("pimId", "equals", pimId)
      .and("_objClass", "equals", "Image")
      .first(),
  );

  if (!obj) {
    throw new Error(`Failed to load scrivito image obj with pimId: ${pimId}`);
  }

  return Scrivito.load(() => obj.contentUrl());
}

const getImageUrlFromSessionStorage = (pimId: string) =>
  sessionStorage.getItem(pimId);
